module.exports = __webpack_public_path__ + "static/childrens-health-9dac679a4c8c84e39944ebcf9f39af3d.png";